// studentActions.js
import {
    FETCH_STUDENTS_REQUEST,
    FETCH_STUDENTS_SUCCESS,
    FETCH_STUDENTS_FAILURE,
    ADD_STUDENT_REQUEST,
    ADD_STUDENT_SUCCESS,
    ADD_STUDENT_FAILURE,
    UPDATE_STUDENT_REQUEST,
    UPDATE_STUDENT_SUCCESS,
    UPDATE_STUDENT_FAILURE,
    DELETE_STUDENT_REQUEST,
    DELETE_STUDENT_SUCCESS,
    DELETE_STUDENT_FAILURE,
    FETCH_STUDENT_PROFILE_REQUEST,
    FETCH_STUDENT_PROFILE_SUCCESS,
    FETCH_STUDENT_PROFILE_FAILURE,
  } from "./actionTypes";
  
  // Fetch students action creators
  export const fetchStudentsRequest = (data) => ({
    type: FETCH_STUDENTS_REQUEST,
    payload: data,
  });
  
  export const fetchStudentsSuccess = (students) => ({
    type: FETCH_STUDENTS_SUCCESS,
    payload: students,
  });
  
  export const fetchStudentsFailure = (error) => ({
    type: FETCH_STUDENTS_FAILURE,
    payload: error,
  });
  
  // Add student action creators
  export const addStudentRequest = (student, onClose) => ({
    type: ADD_STUDENT_REQUEST,
    payload: { student, onClose },
  });
  
  export const addStudentSuccess = (student) => ({
    type: ADD_STUDENT_SUCCESS,
    payload: student,
  });
  
  export const addStudentFailure = (error) => ({
    type: ADD_STUDENT_FAILURE,
    payload: error,
  });
  
  // Update student action creators
  export const updateStudentRequest = (id, student, onClose) => ({
    type: UPDATE_STUDENT_REQUEST,
    payload: { id, student, onClose },
  });
  
  export const updateStudentSuccess = (student) => ({
    type: UPDATE_STUDENT_SUCCESS,
    payload: student,
  });
  
  export const updateStudentFailure = (error) => ({
    type: UPDATE_STUDENT_FAILURE,
    payload: error,
  });
  
  // Delete student action creators
  export const deleteStudentRequest = (studentId) => ({
    type: DELETE_STUDENT_REQUEST,
    payload: studentId,
  });
  
  export const deleteStudentSuccess = (studentId) => ({
    type: DELETE_STUDENT_SUCCESS,
    payload: studentId,
  });
  
  export const deleteStudentFailure = (error) => ({
    type: DELETE_STUDENT_FAILURE,
    payload: error,
  });
  

  //fetch student profile action creators
  export const fetchStudentProfileRequest = (id, params) => ({
  type: FETCH_STUDENT_PROFILE_REQUEST,
  payload: { id, params },
});

export const fetchStudentProfileSuccess = (data) => ({
  type: FETCH_STUDENT_PROFILE_SUCCESS,
  payload: data,
});

export const fetchStudentProfileFailure = (error) => ({
  type: FETCH_STUDENT_PROFILE_FAILURE,
  payload: error,
});